import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';
import { Observable } from 'rxjs';

import { MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH } from 'ish-core/configurations/injection-keys';
import { AppFacade } from 'ish-core/facades/app.facade';
import { DomService } from 'ish-core/utils/dom/dom.service';
import { InjectSingle } from 'ish-core/utils/injection';

import { dotCMSNavigationLink } from '../../../utils/dot-cms-uve-utils';
import { DotCmsUVEHeaderFolderIndexPageCheckComponent } from '../dot-cms-uve-header-folder-index-page-check/dot-cms-uve-header-folder-index-page-check.component';
import { DotCmsUVESubFolderHeaderNavigationComponent } from '../dot-cms-uve-sub-folder-header-navigation/dot-cms-uve-sub-folder-header-navigation.component';

@Component({
  selector: 'custom-dot-cms-uve-desktop-view-header-navigation',
  templateUrl: './dot-cms-uve-desktop-view-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    NgClass,
    DotCmsUVEHeaderFolderIndexPageCheckComponent,
    DotCmsUVESubFolderHeaderNavigationComponent,
  ],
})
export class DotCmsUVEDesktopViewHeaderNavigationComponent implements OnInit {
  readonly navLinks = input<DotCMSNavigationItem>(undefined);
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;
  depth = 1;
  isSticky$: Observable<boolean>;
  stickyHeader: boolean;

  constructor(
    @Inject(MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH)
    public mainNavigationMaxSubCategoriesDepth: InjectSingle<typeof MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH>,
    private domService: DomService,
    private appFacade: AppFacade
  ) {}

  ngOnInit() {
    this.isSticky$ = this.appFacade.stickyHeader$;
  }

  manageLeft(id: number, event?: MouseEvent) {
    const element = document.getElementById(`dot-cms-header-flyout${id}`);
    const div = document.getElementById('globalNavigation');
    const positionElement = document.getElementById(`link${id}`);
    element.style.left = `${positionElement.getBoundingClientRect().left - div.getBoundingClientRect().left}px`;
    if (event) {
      const windowWidth = window.innerWidth;
      const menuItemPosition = (event.target as HTMLElement).getBoundingClientRect();
      const flyoutMenu = this.domService.getElementById(`dot-cms-header-flyout${id}`);
      flyoutMenu.classList.add(windowWidth - menuItemPosition.left < 500 ? 'custom-menu-right' : 'custom-menu-left');
    }
  }
}
